
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Projetos: </label>
    <div class="col-md-9">
      <select class="form-control" [(ngModel)]="projeto" class="form-control">
        <option value="" disabled selected>Selecione...</option>
        <option *ngFor="let item of projetos" [ngValue]="item.codigo">{{item.codigo}} </option>
      </select>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-md-3 col-form-label">Grupos: </label>
    <div class="col-md-9">
      <select class="form-control" [(ngModel)]="grupo" class="form-control">
        <option value="" disabled selected>Selecione...</option>
        <option *ngFor="let item of grupos" [ngValue]="item.codigo">{{item.codigo}} </option>
      </select>
    </div>
  </div>
  <div class="form-group row">
    <div class="controls col-md-9 offset-md-3">
      <button (click)="salvarOnClick()" class="btn btn-primary" type="button">Salvar</button>
      <button (click)="cancelarOnClick()" class="btn btn" type="button">Cancelar</button>
    </div>
  </div>





// WEBPACK FOOTER //
// ./src/app/controle-dados/grupo/modal-grupo.component.html